module.exports = __webpack_public_path__ + "img/14_picasso.fc247ae0.jpg";